import { useCallback, useEffect } from 'react';
import { useRefreshCurrentIndex } from './hooks';
export const useKeyboard = ({ options, setCurrentIndex, currentIndex, onSelect, setOptionsAreOpen, ref, focused, setFocused, optionsAreOpen, selectedValues, mode, }) => {
    useRefreshCurrentIndex({ currentIndex, options, optionsAreOpen, setCurrentIndex });
    const handleKeyDown = useCallback((event) => {
        switch (event.key) {
            case 'ArrowUp':
                if (currentIndex === 0 || currentIndex == null)
                    return;
                setCurrentIndex(currentIndex - 1);
                break;
            case 'ArrowDown':
                if (currentIndex === options.length - 1)
                    return;
                setCurrentIndex((currentIndex ?? 0) + 1);
                break;
            case 'Enter':
                if (currentIndex == null || !onSelect)
                    return;
                if (selectedValues?.includes(options[currentIndex].value))
                    return;
                onSelect(options[currentIndex]);
                if (mode === 'single') {
                    // @ts-ignore
                    document?.activeElement?.blur();
                    setOptionsAreOpen(false);
                    setFocused(false);
                }
                break;
            case 'Escape':
                if (ref?.current && focused) {
                    event.preventDefault();
                    // @ts-ignore
                    document?.activeElement?.blur();
                    setFocused(false);
                    setOptionsAreOpen(false);
                }
                break;
            default:
                break;
        }
    }, [setCurrentIndex, currentIndex, onSelect, options, setOptionsAreOpen, ref, focused, setFocused, mode]);
    useEffect(() => {
        if (optionsAreOpen)
            window.addEventListener('keydown', handleKeyDown);
        if (!optionsAreOpen)
            window.removeEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [options, handleKeyDown, optionsAreOpen]);
};
